import { CdkDragEnd, CdkDragStart } from '@angular/cdk/drag-drop';
import { Component } from '@angular/core';
import { TopicRecord } from '@src/suite/playbook/data-models/records/topic-record';
import { EnpsComponent } from '@suite/common/components/base/enps-component';
import { DataStore } from '@suite/common/data-models/data-store/data-store';
import { Record } from '@suite/common/data-models/records/record';
import { Assignment } from '../assignments-list/assignment/assignment';
import { AssignmentRecord } from '@src/suite/playbook/data-models/records/assignment-record';

@Component({
    template: ""
})
export class DroppableEnpsComponent extends EnpsComponent {

    public appendOnly: boolean = false;
    public dragStarted: boolean = false;
    public draggedObject: Record;
    public draggedGuid: string = null;
    public droppedGuid: string = null;

    public onDragStarted(event: CdkDragStart, guid: string) {
        this.draggedGuid = guid;
        this.dragStarted = true;
        this.appendOnly = true;

        let rec = DataStore.byGuid<Record>(guid, null);
        if (rec) {
            this.draggedObject = rec;
        }
    }

    public onDragEnded(event: CdkDragEnd) {
        this.dragStarted = false;
        this.appendOnly = false;
    }

    public onDragEnter(guid: string) {
        this.droppedGuid = guid;
    }
}